export const WHATSAPP_NUMBER = "919106610959";
